export const isFullStatic = false
export const staticPath = "/app/.nuxt/static-json"
export const publicPath = "https://static.catalog.prod.coursedog.com/89896aa/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"